/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tab_AdministrationInputs */

const en_settings_tab_administration = /** @type {(inputs: Settings_Tab_AdministrationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administration`)
};

const de_settings_tab_administration = /** @type {(inputs: Settings_Tab_AdministrationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administration`)
};

/**
* | output |
* | --- |
* | "Administration" |
*
* @param {Settings_Tab_AdministrationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const settings_tab_administration = /** @type {((inputs?: Settings_Tab_AdministrationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tab_AdministrationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_tab_administration(inputs)
	return de_settings_tab_administration(inputs)
});